/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const DEFAULT_LOCALE = 'en';
export const appName = 'InternalCourseManagerHost';

export const YEAR_GROUPS = [
    { id: '0', value: 'Kindergarten' },
    { id: '1', value: 'Year 1' },
    { id: '2', value: 'Year 2' },
    { id: '3', value: 'Year 3' },
    { id: '4', value: 'Year 4' },
    { id: '5', value: 'Year 5' },
    { id: '6', value: 'Year 6' },
    { id: '7', value: 'Year 7' },
    { id: '8', value: 'Year 8' },
    { id: '9', value: 'Year 9' },
    { id: '10', value: 'Year 10' },
    { id: '11', value: 'Year 11' },
    { id: '12', value: 'Year 12' }
];

export const STATUSES = [
    { id: 0, value: 'Draft' },
    { id: 1, value: 'Reviewed' },
    { id: 2, value: 'Published' },
    { id: 3, value: 'Archived' },
    { id: 4, value: 'Retired' }
];

export const SUPPORTED_LOCALES = [
    { id: 0, value: 'en-AU' },
    { id: 1, value: 'en-CA' },
    { id: 2, value: 'en-GB' },
    { id: 3, value: 'en-IE' },
    { id: 4, value: 'en-NZ' },
    { id: 5, value: 'en-UK' },
    { id: 6, value: 'en-US' },
    { id: 7, value: 'en-ZA' }
];

export const STATUSES_AS_KEY = {
    0: 'Draft',
    1: 'Reviewed',
    2: 'Published',
    3: 'Archived',
    4: 'Retired'
};

export const MASTER_COURSES_ROUTE = '/master-courses';
export const DEFAULT_COURSES_ROUTE = '/default-courses';
export const COURSE_CREATOR_ROUTE = '/course-creator';
export const SET_DEFAULT_COURSES_ROUTE = '/set-default-courses';
export const COURSE_MANAGER_LANDING_SCREEN = 'Course Manager';

export const DROPDOWN_DEFAULT_COUNTRY = 'AUS';
export const DROPDOWN_DEFAULT_COUNTRY_LONG = 'Australia';
export const DROPDOWN_DEFAULT_LOCALE = 'en-AU';
export const DROPDOWN_DEFAULT_COURSE_ID = '10';

export const DEFAULT_COURSE_ID = 0;
export const DEFAULT_PRODUCT_ID = '1';
export const SPELLING_PRODUCT_ID = 10;
export const WRITING_PRODUCT_ID = 11;
export const MATHLETICS_PRODUCT_ID = 1;
export const ARCHIVE_STATUS_KEY = 3;

export const RETIRED_COURSE_ID = 4;

export const DEFAULT_CURRICULUM_TYPE_ID = -1;

export const COUNTRY_ACCESS_STATUS = 2;
export const STATE_ACCESS_STATUS = 3;

export const MASTER_COURSE_ACCESS_KEYS = {
    GLOBAL: 0
};

export const COURSE_CREATOR_SUB_ROUTES = {
    COPY: 'copy',
    CLONE: 'clone',
    EDIT: 'edit'
};

export const PRODUCT_LIST = {
    MATHLETICS: {
        name: 'Mathletics',
        id: 1
    },
    SPELLING: {
        name: 'Spelling',
        id: 10
    },
    WRITING: {
        name: 'Writing',
        id: 11
    }
};

export const PUBLISHED_COURSES = 2;



// WEBPACK FOOTER //
// ./app/constants.js